<div class="di-choix-phone-call">
  <lua-list-item class="list-item" iconColor="CouleurPrimaire" textColor="Noir" iconName="phone_iphone"
    [text]="patient.phone" (click)="call(patient.phone)">
  </lua-list-item>   <lua-list-item class="list-item" iconColor="CouleurPrimaire" textColor="Noir" iconName="phone"
    [text]="patient.phoneFixe" (click)="call(patient.phoneFixe)">
  </lua-list-item> 
</div>